import React from 'react'
import { fragService } from '../../utils/fragments'
import { mapService, mapMetaData } from '../../utils/mapper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Img from 'gatsby-image'

import styles from '../../styles/site'

import MetaData from '../../components/metadata'
import Banner from '../../components/banner'
import Strap from '../../components/strap'
import Quote from '../../components/quote'
import Story from '../../components/story'
import RelatedContent from '../../components/relatedcontent'
import Footer from '../../components/footer'

import { CONTENTTYPES } from '../../utils/constants'

const Service = withStyles(styles)(props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.service)
  const service = mapService(props.data.service)

  return (
    <div>
      <MetaData data={metadata} />
      <Banner
        uid={`services_${service.uid}`}
        title={service.service_headline}
        subtitle={service.service_subtitle}
        // image={service.banner}
      />
      <img
        src={service.banner.src}
        style={{ width: 108, height: 108, marginTop: -116, marginLeft: '65%' }}
      />
      <Strap
        uid={service.uid}
        title={service.lead_title}
        subtitle={service.lead_summary}
        path={props.location.pathname}
      />
      {service.contents &&
        service.contents.map((content, index) => {
          if (content == null) {
            // FIXME: Optional chaining?
            return
          }
          switch (content.type) {
            case CONTENTTYPES.section:
              return <Story key={index} section={content} key={index}/>
            case CONTENTTYPES.quote:
              return <Quote key={index} quote={content} key={index}/>
            case CONTENTTYPES.contentLink:
              return (
                <div className={classes.margins} style={{marginBottom: 60}} key={index}>
                  <RelatedContent
                    service={service.uid}
                    key={index}
                    content={content.content}
                    noBackground
                  />
                </div>
              )
          }
        })}
      <Footer policies={props.data.policies.edges} />
    </div>
  )
})

export default Service

export const query = graphql`
  query serviceQuery($id: String!) {
    service: prismicCtService(id: { eq: $id }) {
      ...service
    }
    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/services/service.js